import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRoute } from '@hvsin/mod-route';
import { useTags } from '../hooks/use-tags.js';
/**
 * 标签列表页
 */
export function TagListPage() {
    const { Link, useNavigate } = useRoute();
    const navigate = useNavigate();
    const { tags, loading, error } = useTags();
    if (loading) {
        return (_jsx("div", { style: styles.page, children: _jsx("div", { style: styles.loading, children: "\u52A0\u8F7D\u4E2D..." }) }));
    }
    if (error) {
        return (_jsx("div", { style: styles.page, children: _jsx("div", { style: styles.error, children: error }) }));
    }
    return (_jsxs("div", { style: styles.page, children: [_jsx("header", { style: styles.header, children: _jsxs("div", { style: styles.headerContent, children: [_jsx("h1", { style: styles.title, children: "\u6807\u7B7E" }), _jsx("p", { style: styles.subtitle, children: "\u6309\u6807\u7B7E\u6D4F\u89C8\u6587\u7AE0" })] }) }), _jsxs("main", { style: styles.main, children: [tags.length === 0 ? (_jsx("div", { style: styles.empty, children: _jsx("p", { style: styles.emptyText, children: "\u6682\u65E0\u6807\u7B7E" }) })) : (_jsx("div", { style: styles.cloud, children: tags.map(tag => (_jsxs(Link, { to: `/post?tagSlugs=${encodeURIComponent(tag.slug)}`, style: {
                                ...styles.tagItem,
                                backgroundColor: tag.color ? `${tag.color}18` : '#eef2ff',
                                borderColor: tag.color || '#c7d2fe',
                            }, children: [_jsxs("span", { style: styles.tagName, children: ["#", tag.name] }), _jsx("span", { style: {
                                        ...styles.countBadge,
                                        backgroundColor: tag.color || '#6366f1',
                                    }, children: tag.postCount })] }, tag.slug))) })), _jsx("div", { style: styles.backLink, children: _jsx(Link, { to: "/post", style: styles.backButton, onClick: (e) => {
                                e.preventDefault();
                                navigate('/post');
                            }, children: "\u2190 \u8FD4\u56DE\u5168\u90E8\u6587\u7AE0" }) })] })] }));
}
const styles = {
    page: {
        minHeight: '100vh',
        backgroundColor: '#fafafa',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        color: '#1a1a1a',
    },
    header: {
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #eaeaea',
        padding: '60px 24px 40px',
        textAlign: 'center',
    },
    headerContent: {
        maxWidth: '720px',
        margin: '0 auto',
    },
    title: {
        margin: '0 0 8px 0',
        fontSize: '32px',
        fontWeight: 700,
        color: '#1a1a1a',
        letterSpacing: '-0.02em',
    },
    subtitle: {
        margin: 0,
        fontSize: '16px',
        color: '#666666',
    },
    main: {
        maxWidth: '720px',
        margin: '0 auto',
        padding: '40px 24px 60px',
    },
    loading: {
        padding: '80px 0',
        textAlign: 'center',
        color: '#999',
        fontSize: '15px',
    },
    error: {
        padding: '16px',
        backgroundColor: '#fff5f5',
        border: '1px solid #fed7d7',
        borderRadius: '8px',
        color: '#c53030',
        fontSize: '14px',
        marginTop: '20px',
    },
    empty: {
        padding: '80px 0',
        textAlign: 'center',
    },
    emptyText: {
        fontSize: '16px',
        color: '#999',
    },
    cloud: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    tagItem: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 14px',
        borderRadius: '20px',
        border: '1px solid',
        textDecoration: 'none',
        color: '#1a1a1a',
        fontSize: '14px',
        fontWeight: 500,
        transition: 'all 0.15s ease',
        cursor: 'pointer',
    },
    tagName: {
        lineHeight: 1,
    },
    countBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '22px',
        height: '22px',
        padding: '0 6px',
        borderRadius: '11px',
        fontSize: '12px',
        fontWeight: 600,
        color: '#ffffff',
    },
    backLink: {
        marginTop: '40px',
        textAlign: 'center',
    },
    backButton: {
        fontSize: '14px',
        color: '#6366f1',
        textDecoration: 'none',
        fontWeight: 500,
    },
};
//# sourceMappingURL=tag-list-page.js.map